module.exports = __webpack_public_path__ + "img/LQuentin Veillas.343fada5.jpg";